import { memo, useMemo } from 'react'
import { useWatch } from 'react-hook-form'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import { api, queryKeys } from '~/api'
import type { StockUnitStockItem } from '~/common/schemas/stock'
import { useProductFormContext } from '~/products/hooks/useProductForm'

type Props = {
    productId: number
    onSelectStockUnit: (stockItem: StockUnitStockItem) => void
}

const useStyles = makeStyles({
    sku: {
        marginRight: 10,
        flex: '1 0 auto',
    },
    errorText: {
        fontSize: '0.9rem',
        marginRight: 10,
    },
})

export default memo(function BundleItemStockItems({ productId, onSelectStockUnit }: Props) {
    const classes = useStyles()
    const {
        data: product,
        isLoading,
        error,
    } = api.products.detail.useQuery(queryKeys.products.detail(productId).queryKey, {
        params: { id: productId },
    })

    if (productId < 0) {
        return null
    }

    if (isLoading) {
        return <Typography>{gettext('Loading...')}</Typography>
    }

    if (error) {
        return <Typography color="error">{gettext('Error loading product')}</Typography>
    }

    return (
        <List>
            {product.body.stock_units.map(({ id, stock_item: stockItem, sku }) => (
                <ListItem
                    key={id}
                    button
                    disabled={stockItem.is_bundle}
                    onClick={() => onSelectStockUnit(stockItem)}
                >
                    <ListItemText className={classes.sku}>{sku}</ListItemText>
                    {stockItem.is_bundle && (
                        <Typography className={classes.errorText}>
                            {gettext('Cannot select bundle SKU as item')}
                        </Typography>
                    )}
                </ListItem>
            ))}
        </List>
    )
})
